import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';  

export default function Home_banner() {
  return (
    <>		
		<section id="services" className="grey-bg services-area pt-120 pb-170 pt-md-60 pt-xs-60 pb-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-xl-6">
						<div className="services-title text-center text-md-start pr-20 mb-35">
							<h2 className="style-text">Service</h2>
							<h6 className="semi-title title-line">Service</h6>
							<h2 className="sect-title">What we transform in real life</h2>
						</div>
					</div>
				</div>
			</div>
			<div className="custom-container-1">
				<div className="services-slide">
				<OwlCarousel items={3.5}  
			className="owl-theme"  
			loop 
			dots={false}			  
			margin={30} 
			responsive= {
                {
                    '1':{
                        items: 1
                    },
                    '768': {
                        items: 2
                    },

					'1200': {
                        items: 3.5
                    }

                }
                
            }
			>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1.png" alt="Services icon" />
							</div>
							<h6>Service 01</h6>
							<h4 className="sub-title">Cyber Security & Data</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1a.png" alt="Services icon" />
							</div>
							<h6>Service 02</h6>
							<h4 className="sub-title">Infrastructure Plan</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1b.png" alt="Services icon" />
							</div>
							<h6>Service 03</h6>
							<h4 className="sub-title">IT Management</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1c.png" alt="Services icon" />
							</div>
							<h6>Service 04</h6>
							<h4 className="sub-title">QA & Testing</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1.png" alt="Services icon" />
							</div>
							<h6>Service 01</h6>
							<h4 className="sub-title">IT Counsultancy</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					<div className="item">
						<div className="single-services">
							<div className="s-icon">
								<img src="assets/img/icon/s-1a.png" alt="Services icon" />
							</div>
							<h6>Service 02</h6>
							<h4 className="sub-title">Business Reform</h4>
							<ul className="text-list">
								<li>Objectively innovate</li>
								<li>Holisticly predominate</li>
								<li>Completely pursue</li>
							</ul>
						</div>
					</div>
					</OwlCarousel>
				</div>
			</div>
		</section>
    </>
  )
}
